/**
 * PageMeta — sets page-specific <title> and <meta> tags via react-helmet-async.
 *
 * Usage:
 *   <PageMeta
 *     title="Canvas Prints | AM Decor Signs & Prints"
 *     description="Gallery-quality canvas prints on premium stretched canvas. Archival inks, solid wood frames, ready to hang."
 *   />
 *
 * All props are optional — defaults to site-level title/description.
 */
import { Helmet } from "react-helmet-async";

const SITE_NAME = "AM Decor Signs & Prints";
const DEFAULT_TITLE = `${SITE_NAME} — Premium Print & Signage, Northern Ireland`;
const DEFAULT_DESCRIPTION =
  "Canvas prints, wall murals, stickers & labels, banners, and vehicle graphics. Premium, configure-first print and signage from Coleraine, Northern Ireland.";

export default function PageMeta({ title, description }) {
  const resolvedTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const resolvedDesc = description || DEFAULT_DESCRIPTION;

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDesc} />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDesc} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
}
